'use client';

import { vars } from '@repo/config';
import Script from 'next/script';
import { useEffect, useState } from 'react';
import { hasConsent } from '@/lib/analytics';

const metaSnippet = (id: string): string =>
  `!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');fbq('init','${id}');fbq('track','PageView');`;

const tiktokSnippet = (id: string): string =>
  `!function(w,d,t){w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie","holdConsent","revokeConsent","grantConsent"];ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);ttq.instance=function(t){for(var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);return e};ttq.load=function(e,n){var r="https://analytics.tiktok.com/i18n/pixel/events.js";ttq._i=ttq._i||{};ttq._i[e]=[];ttq._i[e]._u=r;ttq._t=ttq._t||{};ttq._t[e]=+new Date;ttq._o=ttq._o||{};ttq._o[e]=n||{};var o=d.createElement("script");o.async=!0;o.src=r+"?sdkid="+e+"&lib="+t;var a=d.getElementsByTagName("script")[0];a.parentNode.insertBefore(o,a)};ttq.load('${id}');ttq.page();}(window,document,'ttq');`;

export function MarketingPixels(): React.JSX.Element | null {
  const [granted, setGranted] = useState(false);
  const { metaPixelId, tiktokPixelId } = vars.analytics;

  useEffect(() => {
    if (hasConsent()) {
      setGranted(true);
      return;
    }
    const onGrant = (): void => setGranted(true);
    window.addEventListener('cookie-consent-granted', onGrant);
    return () => window.removeEventListener('cookie-consent-granted', onGrant);
  }, []);

  if (!granted || (!metaPixelId && !tiktokPixelId)) {
    return null;
  }

  return (
    <>
      {metaPixelId ? (
        <Script id="meta-pixel" strategy="afterInteractive">
          {metaSnippet(metaPixelId)}
        </Script>
      ) : null}
      {tiktokPixelId ? (
        <Script id="tiktok-pixel" strategy="afterInteractive">
          {tiktokSnippet(tiktokPixelId)}
        </Script>
      ) : null}
    </>
  );
}
